import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DwConfigService, DwConfigServiceToken } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UnitMemberPdfSectionOption } from '../models/unit-member-pdf.model';

@Injectable({ providedIn: 'root' })
export class UnitMemberPdfService {
  private apiRoot: string;

  constructor(
    private http: HttpClient,
    @Inject(DwConfigServiceToken) configService: DwConfigService
  ) {
    this.apiRoot = configService.coreConfig.apiRoot;
  }

  getOptions(flightSchoolExaminerId: number): Observable<UnitMemberPdfSectionOption[]> {
    return this.http.get<UnitMemberPdfSectionOption[]>(
      `${this.apiRoot}/pilexos/unit-members/${flightSchoolExaminerId}/pdf/options`
    );
  }

  download(flightSchoolExaminerId: number, sectionCodes: string[]): Observable<void> {
    return this.http.post(
      `${this.apiRoot}/pilexos/unit-members/${flightSchoolExaminerId}/pdf`,
      { SectionCodes: sectionCodes || [] },
      { observe: 'response', responseType: 'blob' }
    ).pipe(map(response => this.downloadBlob(response)));
  }

  private downloadBlob(response: HttpResponse<Blob>): void {
    if (!response.body) {
      return;
    }

    const disposition = response.headers.get('content-disposition');
    const match = disposition && /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(disposition);
    const encodedName = match && (match[1] || match[2]);
    const fileName = encodedName ? decodeURIComponent(encodedName) : 'UnitMemberSupplement.pdf';
    const url = window.URL.createObjectURL(response.body);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
